import { ArrowRight, MessageCircle } from "lucide-react";
import { Reveal } from "../components/Reveal";

const WA_LINK = "https://wa.me/919810981090?text=Hi!%20I%20want%20to%20book%20my%20free%20career%20session.";

export const FinalCta = ({ onCta }) => (
  <section className="py-20 sm:py-28" style={{ background: "var(--bg-secondary)" }} data-testid="final-cta-section">
    <div className="max-w-3xl mx-auto px-5 text-center">
      <Reveal>
        <h2 className="font-display text-4xl sm:text-5xl font-semibold uppercase text-white leading-[1.1]" data-testid="final-cta-headline">
          Your Free Career Session Is Just <span style={{ color: "var(--accent)" }}>One Click</span> Away.
        </h2>
      </Reveal>
      <Reveal delay={120}>
        <p className="mt-6 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-body)" }} data-testid="final-cta-body">
          The sooner you start, the sooner you get closer to a real job. It costs nothing to find out your best path.
        </p>
      </Reveal>
      <Reveal delay={240}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button data-testid="final-cta-button" onClick={onCta} className="cta-button inline-flex items-center gap-2 rounded-full px-9 py-4 text-base sm:text-lg font-bold w-full sm:w-auto justify-center">
            Book My Free Session
            <ArrowRight size={20} />
          </button>
          <a
            data-testid="final-whatsapp-button"
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-9 py-4 text-base font-semibold w-full sm:w-auto justify-center transition-colors hover:text-white"
            style={{ border: "1px solid var(--input-border)", color: "var(--text-body)" }}
          >
            <MessageCircle size={20} style={{ color: "var(--accent)" }} />
            Chat on WhatsApp
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export const StickyMobileBar = ({ onCta, hidden }) => (
  <div
    data-testid="sticky-mobile-cta"
    className={`fixed bottom-0 inset-x-0 z-40 sm:hidden p-3 transition-transform duration-300 ${hidden ? "translate-y-full" : ""}`}
    style={{ background: "rgba(26, 33, 48, 0.92)", backdropFilter: "blur(12px)", borderTop: "1px solid var(--input-border)" }}
  >
    <button data-testid="sticky-cta-button" onClick={onCta} className="cta-button w-full rounded-full py-3.5 text-base font-bold">
      Book My Free Session
    </button>
  </div>
);

export const WhatsAppFloat = ({ hidden }) => (
  <a
    data-testid="whatsapp-float-button"
    href={WA_LINK}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    className={`wa-float fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-40 rounded-full flex items-center justify-center transition-transform hover:scale-110 ${hidden ? "hidden" : ""}`}
    style={{ background: "var(--bg-card)", border: "1px solid rgba(14, 217, 181, 0.35)", width: 52, height: 52 }}
  >
    <MessageCircle size={24} style={{ color: "var(--accent)" }} />
  </a>
);
